<div class="popup" style="width:300px">

    <!-- Header -->
    <h3 mat-dialog-title>
        Select Language
    </h3 >

    <!-- Body -->
    <mat-dialog-content>

        <!-- Language selection -->
        <form style="padding-left:100px;">
            <mat-radio-group name="language"
                [(ngModel)]="registerNewFamily.language">
                <mat-radio-button value="en">
                    English
                </mat-radio-button>
                <br />
				<mat-radio-button value="es">
                    Español
				</mat-radio-button>
                <br />
                <mat-radio-button *ngIf="isV10" value="fr">
                    Français
                </mat-radio-button>
                <br />
            </mat-radio-group>
        </form>
    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions style="position: sticky">
        <div class="footerRight">
            <tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>
            <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>
        </div>
	</mat-dialog-actions>
</div>
